import {
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SQFT_FEATURES
} from "../../../constants";
import {MINIMUM_TALL_CABINET_HEIGHT} from "../../../helpers/sqftCabinetsDataMapper";

const KITCHEN_CABINET_DRAG_PART_IDS = [
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
  SQFT_FEATURES.upper_cabinet_boxes,
  SQFT_FEATURES.lower_cabinet_boxes,
  SQFT_FEATURES.tall_cabinet_boxes
];

const KITCHEN_CABINET_DRAG_BUTTONS = [
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall
];

let activeDraggedFeatureData = null;

const cabinetFeatureDragHelper = {
  setActiveDraggedFeatureData(draggedFeatureData) {
    activeDraggedFeatureData = draggedFeatureData;
  },

  clearActiveDraggedFeatureData() {
    activeDraggedFeatureData = null;
  },

  getActiveDraggedFeatureData() {
    return activeDraggedFeatureData;
  },

  isTallCabinetDrag(activeButton) {
    if (!activeDraggedFeatureData) {
      return false;
    }

    const draggedHeight = Number(activeDraggedFeatureData.height);
    const isKitchenCabinetDrag = KITCHEN_CABINET_DRAG_PART_IDS.includes(activeDraggedFeatureData.partId)
      || KITCHEN_CABINET_DRAG_BUTTONS.includes(activeButton);

    return isKitchenCabinetDrag && draggedHeight > MINIMUM_TALL_CABINET_HEIGHT;
  }
};

export default cabinetFeatureDragHelper;
